import { useEffect } from "react";
import { GET_ALL_SITE_CONFIGS } from "../../helpers/Constant";
import { useGetAllData } from "./useGetAllData";

export default function AdminBrandingSync() {
    const { dataList } = useGetAllData(GET_ALL_SITE_CONFIGS);
    const siteConfig = dataList?.[0] || {};

    useEffect(() => {
        const siteTitle = siteConfig.siteTitle || "FAST WIN BD";
        const faviconHref = "/fastwin-fw-v1.svg";

        document.title = siteTitle;

        const upsertIconLink = (rel) => {
            let link = document.querySelector(`link[rel='${rel}']`);
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", rel);
                document.head.appendChild(link);
            }
            link.setAttribute("href", faviconHref);
        };

        upsertIconLink("icon");
        upsertIconLink("apple-touch-icon");
    }, [siteConfig]);

    return null;
}
